__turbopack_context__.v({
  "breadcrumbWrap": "Coupons-module__knIIEG__breadcrumbWrap",
  "card": "Coupons-module__knIIEG__card",
  "cardDesc": "Coupons-module__knIIEG__cardDesc",
  "cardFooter": "Coupons-module__knIIEG__cardFooter",
  "cardLink": "Coupons-module__knIIEG__cardLink",
  "cardTitle": "Coupons-module__knIIEG__cardTitle",
  "categoryBadge": "Coupons-module__knIIEG__categoryBadge",
  "clearBtn": "Coupons-module__knIIEG__clearBtn",
  "codeBox": "Coupons-module__knIIEG__codeBox",
  "codeText": "Coupons-module__knIIEG__codeText",
  "copyBtn": "Coupons-module__knIIEG__copyBtn",
  "couponDate": "Coupons-module__knIIEG__couponDate",
  "couponDate2": "Coupons-module__knIIEG__couponDate2",
  "emptyState": "Coupons-module__knIIEG__emptyState",
  "filterCheckbox": "Coupons-module__knIIEG__filterCheckbox",
  "filterGroup": "Coupons-module__knIIEG__filterGroup",
  "filterGroupTitle": "Coupons-module__knIIEG__filterGroupTitle",
  "filterLabel": "Coupons-module__knIIEG__filterLabel",
  "filterList": "Coupons-module__knIIEG__filterList",
  "filterOption": "Coupons-module__knIIEG__filterOption",
  "grid": "Coupons-module__knIIEG__grid",
  "layout": "Coupons-module__knIIEG__layout",
  "loadingWrap": "Coupons-module__knIIEG__loadingWrap",
  "mobileFilters": "Coupons-module__knIIEG__mobileFilters",
  "mobileSelect": "Coupons-module__knIIEG__mobileSelect",
  "mobileSelectChevron": "Coupons-module__knIIEG__mobileSelectChevron",
  "mobileSelectWrap": "Coupons-module__knIIEG__mobileSelectWrap",
  "page": "Coupons-module__knIIEG__page",
  "sidebar": "Coupons-module__knIIEG__sidebar",
  "sidebarHeader": "Coupons-module__knIIEG__sidebarHeader",
  "sidebarTitle": "Coupons-module__knIIEG__sidebarTitle",
  "validTill": "Coupons-module__knIIEG__validTill",
});
